import React, { useEffect, useState } from 'react'
import Navigation from '../../Components/Navigation'
import './printer.css'
import SearchIcon from '@mui/icons-material/Search'
import { images } from 'Assets/Images'
import { CustomSelector } from './components/CustomSelector'
import { usePrinterContext } from 'state/context/PrinterTemplatesContext'
import { CounterImpressions } from './components/CounterImpressions'
import {
  getPrintedProductsService,
  getProductsToPrintService,
} from 'redux/services/printerServices'
import { TableProductListPrinter } from './components/TableProductListPrinter'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { TablePrintedProductList } from './components/TablePrintedProductList'
import { StringParam, useQueryParams } from 'use-query-params'
import { useSelector } from 'react-redux'
import { FormatedDate } from 'Utils/functions'

export const PRINT_MANUAL_URL =
  'https://staludraqa.blob.core.windows.net/aludra-files/2/Asset/Models/06062024201928.pdf'
const columns = [
  {
    Header: 'Check',
    accessor: 'Check',
    hideEnabled: false,
  },
  {
    Header: 'Departamento',
    accessor: 'DepartmentName',
    hideEnabled: false,
  },
  {
    Header: 'Tipo',
    accessor: 'ListType',
    hideEnabled: false,
  },
  {
    Header: 'Referencia',
    accessor: 'Sku',
    hideEnabled: false,
  },
  {
    Header: 'Descripción',
    accessor: 'ProductName',
    hideEnabled: false,
  },
  {
    Header: 'Precio',
    accessor: 'Precio',
    children: [{ Header: 'Base' }, { Header: 'Oferta' }],
    hideEnabled: true,
  },
  {
    Header: 'Vigencia',
    accessor: 'Vigencia',
    children: [{ Header: 'Fecha inicio' }, { Header: 'Fecha fin' }],
    hideEnabled: true,
  },
]
const columnsPrinted = [
  {
    Header: 'Imagen',
    accessor: 'Imagen',
    hideEnabled: false,
  },
  {
    Header: 'Descripción',
    accessor: 'Descripción',
    hideEnabled: false,
  },
  {
    Header: 'Tipo',
    accessor: 'Tipo',
    hideEnabled: false,
  },
  {
    Header: 'Acciones',
    accessor: 'Acciones',
    hideEnabled: false,
  },
]
const templatesOptions = [
  {
    value: 'Precio Regular',
    key: 'REGULAR',
    template: 'REGULAR',
  },
  { value: 'Precio Oferta', key: 'OFFER', template: 'OFFER' },
  {
    value: 'Precio Regular CMF',
    key: 'REGULAR',
    template: 'REGULAR_CMF',
  },
  {
    value: 'Precio Oferta CMF',
    key: 'OFFER',
    template: 'OFFER_CMF',
  },
  {
    value: 'Precio Especial CMF',
    key: 'REGULAR_CMF',
    template: 'SPECIAL_CMF',
  },
]

const PRINTED = 'PRINTED'
const PENDING = 'PENDING'
const defaultValue = {
  REGULAR_CMF: { name: 'Precio Regular CMF', key: 'REGULAR' },
  REGULAR: { name: 'Precio Regular', key: 'REGULAR' },
  OFFER: { name: 'Precio Oferta', key: 'OFFER' },
  OFFER_CMF: { name: 'Precio Oferta CMF', key: 'OFFER' },
  SPECIAL_CMF: { name: 'Precio Especial CMF', key: 'REGULAR_CMF' },
}
const DEFAULT_TEMPLATES_CONTENT = [
  {
    page: 1,
    template: null,
    content: {
      products: [],
    },
  },
]

const Printer = () => {
  const { CompanyId, WarehouseId } = useSelector(state => state.company)
  const [departmentFilter, setDepartmentFilter] = useState('')
  const [searchParam, setSearchParam] = useQueryParams({ type: StringParam })
  const {
    setSelectedTemplateType,
    setSelectedProducts,
    setAllTemplatesContent,
    setCurrentPage,
  } = usePrinterContext()
  const [loading, setLoading] = useState(false)
  const [departments, setDepartments] = useState([])
  const [hasDateFilter, setHasDateFilter] = useState(false)
  const defaultOption = {
    type: {
      value: 'Etiquetas pendientes por impresión',
      key: 'PENDING',
    },
    template: {
      value:
        defaultValue[searchParam?.type]?.name || defaultValue.REGULAR_CMF.name,
      key: defaultValue[searchParam?.type]?.key || 'REGULAR',
    },
  }
  const [selectedOption, setSelectedOption] = React.useState(
    searchParam?.type
      ? defaultOption
      : { type: { key: '', value: '' }, template: { key: '', value: '' } }
  )

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [pageSize, setPageSize] = useState(10)

  const handleOptionType = option => {
    setSearchText('')
    setDepartmentFilter('')
    setHasDateFilter(false)
    setSelectedOption({
      template: {
        key: '',
        value: '',
      },
      type: option,
    })
    setSelectedTemplateType({
      key: '',
      value: '',
    })
    setData([])
    setSearchParam({ type: undefined })
    setSelectedProducts([])
    setAllTemplatesContent(DEFAULT_TEMPLATES_CONTENT)
    setCurrentPage(1)
  }
  const handleOptionTemplate = option => {
    setAllTemplatesContent(DEFAULT_TEMPLATES_CONTENT)
    setSearchText('')
    setSelectedOption({ ...selectedOption, template: option })
    setSelectedTemplateType(option)
    setSearchParam({ type: undefined })
    setSelectedProducts([])
    setDepartmentFilter('')
    setHasDateFilter(false)
    setCurrentPage(1)
  }

  const fetchPrintedProducts = async ({
    searchText,
    type,
    pageSize,
    currentPage,
  }) => {
    try {
      setLoading(true)
      const response = await getPrintedProductsService({
        SearchText: searchText || '',
        Type: type || 'ALL',
        PageNumber: currentPage || 1,
        PageSize: pageSize || 10,
      })
      const data = response.map(product => ({
        ...product,
        Imagen: product.ImageProduct,
        Descripción: product.Name,
        Tipo: product.ListType,
        Acciones: product.DocumentUrl,
        currentPage: currentPage || 1,
      }))
      setData(data)
    } catch (error) {
      console.log('fetchPrintedProducts -> error', error)
    } finally {
      setLoading(false)
    }
  }
  const fetchProductsToPrint = async ({
    type,
    searchText,
    pageSize,
    currentPage,
    StartDate,
    FinishDate,
    departmentId,
  }) => {
    try {
      setLoading(true)
      const isCleanFilter = departmentId === 'none'
      const depFilterToApply = isCleanFilter ? '' : departmentId
      setDepartmentFilter(depFilterToApply || '')
      const defDepFilter = isCleanFilter ? null : departmentFilter
      setHasDateFilter(StartDate || FinishDate)

      const response = await getProductsToPrintService({
        WarehouseId,
        CompanyId,
        SearchText: searchText || '',
        Type: type || 'REGULAR',
        State: 'PENDING',
        PageNumber: currentPage || 1,
        PageSize: pageSize || 10,
        StartDate: StartDate || '',
        FinishDate: FinishDate || '',
        DepartmentId: depFilterToApply || defDepFilter || null,
      })
      const data = response.map(product => ({
        ...product,
        Check: '',
        DepartmentName: product.DepartmentName,
        ListType: product.ListType,
        Sku: product.Sku,
        ProductName: product.ProductName,
        Precio: [product.BasePrice, product.Price],
        Vigencia: [
          product.StartDate ? FormatedDate(product.StartDate.slice(0, 10)) : '',
          product.FinishDate
            ? FormatedDate(product.FinishDate.slice(0, 10))
            : '',
        ],
        currentPage: currentPage || 1,
      }))
      setData(data)
    } catch (error) {
      console.log('fetchProductsToPrint -> error', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSearch = async () => {
    try {
      if (selectedOption.type.key === PRINTED) {
        await fetchPrintedProducts({
          type: selectedOption.template.template,
          searchText,
        })
        return
      }
      await fetchProductsToPrint({
        type: selectedOption.template.key,
        searchText,
        departmentId: departmentFilter,
      })
    } catch (error) {
      console.log('handleSearch -> error', error)
    }
  }

  useEffect(() => {
    if (selectedOption.type.key && selectedOption.template.key) {
      if (selectedOption.type.key === PRINTED) {
        fetchPrintedProducts({
          type: selectedOption.template.template,
        })
      }
      if (selectedOption.type.key === PENDING) {
        fetchProductsToPrint({
          type: selectedOption.template.key,
        })
      }
    }
  }, [selectedOption, CompanyId, WarehouseId])

  return (
    <>
      <Navigation />
      <section className="printer-screen-wrapper" data-testid="printer-wrapper">
        <div className="printer-header-wrapper">
          <h2>Impresión de plantillas de precios</h2>
          <div className="printer-header-buttons">
            <button
              disabled
              className="printer-header-button"
              data-testid="btn-quickprint-printer">
              Impresión rápida
            </button>
            <button
              className="printer-header-button"
              data-testid="btn-manual-printer"
              onClick={() => window.open(PRINT_MANUAL_URL, '_blank')}>
              Manual de impresión
            </button>
          </div>
        </div>
        <div style={{ padding: '0 10px' }}>
          <CounterImpressions />
          <div className="printer-options-wrapper">
            <CustomSelector
              placeholder="Selecciona qué desea visualizar"
              options={[
                { value: 'Etiquetas pendientes por impresión', key: PENDING },
                { value: 'Etiquetas impresas', key: PRINTED },
              ]}
              selectedOption={selectedOption.type}
              handleOption={handleOptionType}
              disabled={loading}
            />
            <CustomSelector
              placeholder="Selecciona el tipo de plantilla"
              options={[
                ...templatesOptions,
                ...(selectedOption.type.key === PRINTED
                  ? [{ value: 'Todos', key: 'ALL' }]
                  : []),
              ]}
              selectedOption={selectedOption.template}
              handleOption={handleOptionTemplate}
              disabled={!selectedOption.type.key || loading}
            />
            <div className="printer-option-input template-terms-wrapper-to-remove">
              <input
                data-testid="input-search-printer"
                className="printer-option-input-text"
                disabled={!selectedOption.type.key || loading}
                value={searchText}
                onChange={e => setSearchText(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleSearch()}
                placeholder="Buscar por descripción del producto o código"
              />
              <SearchIcon
                data-testid="btn-search-printer"
                style={{ width: 30, height: 30, marginRight: 10 }}
                onClick={handleSearch}
              />
            </div>
          </div>
          <div
            className="printer-table-wrapper"
            data-testid="container-printer-table-wrapper">
            {loading && (
              <div className="printer-table-loader-wrapper">
                <FontAwesomeIcon
                  icon={faSpinner}
                  className="spinner"
                  style={{ width: 50 }}
                />
                <p>
                  Esto puede tardar unos segundos, <br /> por favor espera un
                  momento
                </p>
              </div>
            )}
            {!!data?.length &&
              !loading &&
              selectedOption.type.key === PENDING && (
                <TableProductListPrinter
                  data={data}
                  columns={columns}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  selectedDepartment={departmentFilter}
                  selectedOption={selectedOption}
                  departmentState={{ departments, setDepartments }}
                  handleGetData={val =>
                    fetchProductsToPrint({
                      type: selectedOption.template.key,
                      pageSize: val.pageSize,
                      currentPage: val.currentPage,
                      StartDate: val.StartDate,
                      FinishDate: val.FinishDate,
                      departmentId: val.departmentId,
                    })
                  }
                />
              )}
            {!!data?.length &&
              !loading &&
              selectedOption.type.key === PRINTED && (
                <TablePrintedProductList
                  data={data}
                  columns={columnsPrinted}
                  pageSize={pageSize}
                  selectedOption={selectedOption}
                  setPageSize={setPageSize}
                  handleGetData={val =>
                    fetchPrintedProducts({
                      type: selectedOption.template.template,
                      pageSize: val.pageSize,
                      currentPage: val.currentPage,
                    })
                  }
                />
              )}
            {!data?.length && !loading && !selectedOption?.template?.key && (
              <div className="printer-instructions-wrapper">
                <div className="printer-instructions-header">
                  <img
                    src={images.printer.note}
                    alt=""
                    className="printer-instructions-header-image"
                  />
                  <div className="printer-instructions-header-content">
                    <p className="printer-instructions-header-item-title">
                      Puedes consultar las plantillas de impresión
                    </p>
                    <p className="printer-instructions-header-item-sub-title">
                      Solo debes filtrar seleccionado:
                    </p>
                    <div className="printer-instructions-header-item">
                      <img
                        src={images.printer.checkIcon}
                        alt=""
                        className="printer-instructions-header-item-image"
                      />
                      <p className="printer-instructions-header-item-text">
                        Qué deseas visualizar
                      </p>
                    </div>
                    <div className="printer-instructions-header-item">
                      <img
                        src={images.printer.checkIcon}
                        alt=""
                        className="printer-instructions-header-item-image"
                      />
                      <p className="printer-instructions-header-item-text">
                        Tipo de plantilla
                      </p>
                    </div>
                  </div>
                </div>
                <div className="printer-instructions-footer-wrapper">
                  <p className="printer-instructions-footer-text">
                    Una vez que se muestre la lista según tu selección, se
                    activará el buscador.
                  </p>
                  <p className="printer-instructions-footer-text">
                    Puedes buscar por descripción del producto o código.
                  </p>
                </div>
              </div>
            )}
            {!data?.length &&
              !loading &&
              !departmentFilter &&
              selectedOption?.type?.key &&
              selectedOption?.template?.key && (
                <div className="printer-table-loader-wrapper">
                  <p className="printer-instructions-header-item-sub-title">
                    {selectedOption?.type?.key === PRINTED
                      ? 'No hay productos impresos en los últimos 7 días'
                      : 'No hay precios pendientes por imprimir en los últimos 7 días'}
                  </p>
                  {(searchText || hasDateFilter) && (
                    <button
                      data-testid="btn-clearfilter-printer"
                      className="printer-table-loader-wrapper-button"
                      onClick={() => {
                        setDepartmentFilter('')
                        setHasDateFilter(false)
                        setSearchText('')
                        if (selectedOption?.type?.key === PRINTED) {
                          fetchPrintedProducts({
                            type: selectedOption.template.template,
                            searchText: '',
                          })
                          return
                        }
                        fetchProductsToPrint({
                          type: selectedOption.template.key,
                          departmentId: 'none',
                          searchText: '',
                        })
                      }}>
                      Quitar filtro
                    </button>
                  )}
                </div>
              )}
            {!data?.length &&
              !loading &&
              departmentFilter &&
              selectedOption?.type?.key &&
              selectedOption?.template?.key && (
                <div className="printer-table-loader-wrapper">
                  <p className="printer-instructions-header-item-sub-title">
                    No hay precios pendientes por imprimir para este
                    departamento en los últimos 7 días
                  </p>
                  <button
                    data-testid="btn-cleardepartmentfilter-printer"
                    className="printer-table-loader-wrapper-button"
                    onClick={() => {
                      setDepartmentFilter('')
                      setHasDateFilter(false)
                      setSearchText('')
                      fetchProductsToPrint({
                        type: selectedOption.template.key,
                        departmentId: 'none',
                        searchText: '',
                      })
                    }}>
                    Quitar filtro
                  </button>
                </div>
              )}
          </div>
        </div>
      </section>
    </>
  )
}

export default Printer
